module.exports = __webpack_public_path__ + "static/media/34.e972ed86.png";